import * as types from "../../actions/ActionTypes";

const initialState = {
    loading: false,
    data: null,
    error: null,
    cache: {}, // { module: { data, userLocation } }
    currentModule: null, // track which module's data is currently loaded
};

const getReachDistanceDataReducer = (state = initialState, action) => {
    switch (action.type) {
        case types.GET_REACH_DATA_DISTANCE_START:
            return {
                ...state,
                loading: true,
                error: null,
            };

        case types.GET_REACH_DATA_DISTANCE_SUCCESS:
            const moduleType = action.payload.moduleType || "default";
            const userLocation = action.payload.userLocation;

            return {
                ...state,
                loading: false,
                data: action.payload.data,
                error: null,
                cache: {
                    ...state.cache,
                    [moduleType]: {
                        data: action.payload.data,
                        userLocation: userLocation,
                    },
                },
                currentModule: moduleType,
            };

        case types.GET_REACH_DATA_DISTANCE_ERROR:
            return {
                ...state,
                loading: false,
                error: action.payload,
            };

        default:
            return state;
    }
};

export default getReachDistanceDataReducer;
